<template>
  <modal v-if="isOpen" class-name="warranty-modal" @close="$emit('close')">
    <template #header>
      <h2>Garantietarife auf einen Blick</h2>
    </template>
    <template #body>
      <table>
        <tr>
          <td class="title">Basic</td>
          <td class="gray"><i class="fas fa-check" /></td>
          <td class="gray"><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td class="big-cell"><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
        </tr>
        <tr>
          <td class="title">Klassik</td>
          <td class="gray"><i class="fas fa-check" /></td>
          <td class="gray"><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td class="big-cell"><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-times" /></td>
        </tr>
        <tr>
          <td class="title">Premium</td>
          <td class="gray"><i class="fas fa-check" /></td>
          <td class="gray"><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
          <td class="big-cell"><i class="fas fa-times" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-times" /></td>
        </tr>
        <tr>
          <td class="title">Premium-Plus</td>
          <td class="gray"><i class="fas fa-check" /></td>
          <td class="gray"><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td class="big-cell"><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
          <td><i class="fas fa-check" /></td>
        </tr>
        <tr class="blocks">
          <td></td>
          <td class="gray" colspan="2">Motor</td>
          <td colspan="3">Getriebe/Differential</td>
          <td colspan="2">Lenkung</td>
          <td colspan="2">Bremssystem</td>
          <td colspan="2">Kühlsystem</td>
          <td colspan="2">Heizung und Klimaalage</td>
          <td colspan="2">Gemischaufbereitung</td>
          <td colspan="2">Elektrik</td>
          <td colspan="2">Komfortelektrik</td>
          <td colspan="2">Kraftübertragung</td>
          <td colspan="2">Abgasanlage</td>
          <td colspan="2">Sicherheitssysteme</td>
          <td class="big-cell">Niveauregulierung</td>
          <td colspan="2">Motoraufladung</td>
        </tr>
        <tr class="details">
          <td></td>
          <td>
            Kurbelwelle
            Kurbelwellenlager
            Pleuel
            Kolben
            Kolbenringe
            Kolbenbolzen
            Zylinder
            Nockenwelle
            Nockenwellenlager
            Kipphebel
            Schwinghebel
            Schlepphebel
            Ein- und Auslassventile
            Ventilführungen
            Stößel
            Steuerkette
            Steuerketten - führungsschienen
            Steuerketten - spannschienen
            Steuerkettenräder
            Ölpumpe
            Laufbuchsen
            Pleuellager
          </td>
          <td>
            Exzenterwelle
            Ausgleichswelle
            Kettenspanner
          </td>
          <td>
            Zahnräder
            Hauptwelle
            Vorgelegewelle
            Nebenwelle
            Synchronringe
            Lager
            Planetengetriebe
            Primärwelle
            Sekundärwelle
          </td>
          <td>
            Drehmomentwandler
            Antriebskette
          </td>
          <td>
            hydraulische
            Steuereinheit
            Ölpumpe
          </td>
          <td>
            Mechanisches,
            hydraulisches
            und elektrisches
            Lenkgetriebe mit
            allen Innenteilen
            hydraulische
            Servopumpe
            elektrische
            Servopumpe
          </td>
          <td>
            Elektrisch
            verstellbare
            Lenksäule
            Lenkradverriegelung
            Lenkwinkelsensor
            Wickelfederkassette
          </td>
          <td>
            Hauptbremszylinder
            Bremskraftverstärker
            Vakuumpumpe
            Bremskraftregler
            Bremskraftbegrenzer
          </td>
          <td>
            ABS-Steuergerät
            Drehzahlfühler
            Hydraulikeinheit
            Bremslichtschalter
            Bremssattel
          </td>
          <td>
            Wasserkühler
            des Motors
            Heizungs - wärmetauscher
            Thermostat
            Wasserpumpe
            elektrische
            Zusatzwassserpumpe
          </td>
          <td>
            Kühler für
            Automatikgetriebe
            AGR-Kühler
            Ölkühler
            Viscolüfter
            Thermolüfter
            Lüfterkupplung
            Thermoschalter
            Temperatursensor
            Füllstandgeber
            Zylinderkopfdichtung
          </td>
          <td>
            Steuergerät
            der Heizungs- und
            Klimaanlage
            Gebläsemotor
            Klimakompressor
            Verdampfer
            Lüfter
            Kondensator
          </td>
          <td>
            Bedienelement
            der Heizungs- und
            Klimaanlage
            Stellmotoren
            der Lüftungsklappen
            Temperaturfühler
            Gebläseendstufe
            Expansionsventil
            Druckschalter
          </td>
          <td>
            Kraftstoffförderpumpe
            Einspritzpumpe
            Motorsteuergerät
          </td>
          <td>
            Magnetventile und
            Hydraulikventile der
            Motorsteuerung
            Pumpe-Düse-Einheit
            Einspritzdüsen
            Injektoren
            Steuergerät
            Drosselklappengehäuse
            Drosselklappenschalter
            Zentraleinspritzeinheit
            Luftmassenmesser
            Luftmengenmesser
            Kraftstoffmengenteiler
            Kraftstoffdruckregler
            Klopfsensoren
            Temperatursensoren
            Nockenwellensensoren
            Kurbelwellensensoren
            Saugrohrdrucksensor
            Leerlaufsteller
            Stellmotor der
            Drallklappen
          </td>
          <td>
            Generator mit Regler
            und Generatorfreilauf
            Anlasser mit
            Magnetschalter
            Zündspulen
            Verteiler
            Getriebesteuergerät
            Scheibenwischermotor
            vorne und hinten
            Hupe
            Signalhorn
            Kraftstofffüllstandgeber
          </td>
          <td>
            Kombiinstrument
            (Schalttafeleinsatz)
            Vorglührelais/
            Steuergerät
            Waschwasserpumpe
            Ölstandsensor
            Ölniveausensor
          </td>
          <td>
            Fensterhebermotor
            Fensterheberschalter
            Fensterhebermechanik
            Schiebedachmotor
            Schiebedachschalter
            Zentralverriegelung mit
            folgenden Bauteilen:
            Türschlösser
            Heckklappenschloss
            Heckscheiben - heizungselemente
          </td>
          <td>
            Steuergerät Fensterheber
            Schiebedachmechanik
            Schiebedachsteuergerät
            Zentralverriegelung mit
            folgenden Bauteilen:
            Schalter
            Funkfernbedienung
            Türgriffe bei Keyless Go
            Zentralverriegelungs- steuergerät
            Frontscheibenheizung- selemente
            Regensensor
            Lichtsensor
            Sitzheizungs- steuergerät
            Sitzheizungsmatten
            Sitzheizungsschalter
            Parkdistanzkontrolle
            mit den Bauteilen:
            Ultraschallsensoren vorne
            und hinten
            Signalgeber
            folgende Teile des
            Cabrioverdecks:
            Hydraulikzylinder
            Hydraulikpumpe
            Steuergerät
          </td>
          <td>
            Zahnriemen
            (Steuerriemen)1
            Spannrolle
            vom Zahnriemen
            Umlenkrolle
            vom Zahnriemen
            Ölfiltergehäuse
            Öldruckschalter
            von der
            Antriebsschlupfregelung:
            Umschaltventil
            Sensoren für
            Querbeschleunigung
            Sensoren für
            Bremsdruck
            Drehzahlsensoren
            Hydraulikeinheit
            Druckspeicher
            Ladepumpe
          </td>
          <td>
            Kardanwelle
            Antriebswellen
            Antriebswellengelenke
            ABS-Sensorring
            Kupplungsnehmerzylinder
            Kupplungsgeberzylinder
            Zweimassenschwungrad
          </td>
          <td>
            Lambda-Sonde
            AGR-Ventil
          </td>
          <td>
            Flexibles
            Hosenrohr
            Katalysator
            NOX-Sensor
            Differenzdrucksensor
            Abgastemperatursensor
            Abgasgegendrucksensor
          </td>
          <td>
            Airbag
            Gurtstraffer
          </td>
          <td>
            AirbagSteuergerät
            Sitzbelegungssensor
            Crash-Sensor
            Beschleunigungssensor
            Wickelfederkassette
            Schalter Beifahrerabschaltung
          </td>
          <td class="big-cell">
            <ul>
              <li>Hydropneumatische</li>
              <li>Stoßdämpfer</li>
              <li>Kompressor</li>
              <li>Höhenstandsensor</li>
            </ul>
          </td>
          <td>
            Turbolader
            Kompressor
            Ladeluftkühler
          </td>
          <td>
            variable
            Turboladerverstellung
            Wastegateklappe
            Stellmotor der
            elektronischen
            Turboladerverstellung
            Schubumluftventil
            Ladedrucksensor
            Ladedruckregelventil
          </td>
        </tr>
      </table>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};

</script>

<style lang="scss" scoped>
.warranty-modal {
  h2 {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    @include breakpoint(desktop) {
      margin-bottom: 40px;
      font-size: 30px;
    }
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 2000px;
    .blocks {
      td {
        height: 50px;
        font-weight: 700;
      }
    }
    .details {
      td {
        padding: 10px;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        vertical-align: top;
      }
    }
    td {
      text-align: center;
      height: 40px;
      width: 170px;
      border: 1px solid #d8d8d8;
      &:first-child {
        border-left: none;
      }
      &.big-cell {
        width: 250px;
      }
      &.gray {
        background-color: $gray;
      }
    }
    .title {
      text-align: left;
      font-size: 16px;
      font-weight: 700;
      line-height: 40px;
    }
    .fa-check {
      color: $green;
    }
    .fa-times {
      color: $red;
    }
  }
}
</style>

<style lang="scss">
.warranty-modal {
  .modal-wrapper {
    @include breakpoint(bigdesktop) {
      min-width: 1100px;
    }
  }
}
</style>
